import { observer } from "mobx-react";
import React from "react";
import { API } from "../Network/API";
import "./Formular.css"; // styles
import "./Checkbox.css"; // styles
import { APIClient } from "network-stapler";
import { generalConfigurationStore as store } from "../Stores/GeneralConfigurationStore";
import FormInput from "./FormInput";
import MiniLoadingIndicatorWrapper from "./MiniLoadingIndicator";
import ReCAPTCHA from "react-google-recaptcha";
import { RECAPTCHA_KEY } from "../config";

type Props = {
	apiClientDynamicBaseUrl: APIClient;
};

type State = {
	firstname: string;
	lastname: string;
	email: string;
	phone: string;
	message: string;
	postcode: string;
	address: string;
	city: string;
	country: string;
	response?: any; // contact form 7 response
	isSending: boolean;
	configuration291: string;
	acceptDataPrivacy: string;
};

@observer
class Formular extends React.Component<Props, State> {
	notificationRef: any;
	recaptchaRef: any;

	constructor(props: Props) {
		super(props);

		this.notificationRef = React.createRef();
		this.recaptchaRef = React.createRef();

		// set initial state in constructor directly
		this.state = {
			firstname: "",
			lastname: "",
			email: "",
			phone: "",
			postcode: store.zipZonesStore?.latestZipzoneInput || "",
			city: "",
			country: "",
			address: "",
			message: "",
			isSending: false,
			configuration291: "",
			acceptDataPrivacy: "",
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleSubmit = async (event: any) => {
		if (!store.productConfigurationStore || !store.zipZonesStore?.selectedPartner) return;

		this.setState({ response: undefined });

		event.preventDefault();
		if (this.state.isSending) {
			return;
		}

		this.setState({ isSending: true });

		// get recaptcha token
		const token = await this.recaptchaRef.current.executeAsync();

		// apply to form data
		const emailBody: { [key: string]: string } = {
			firstname: this.state.firstname,
			lastname: this.state.lastname,
			email: this.state.email,
			message: this.state.message,
			postcode: this.state.postcode,
			address: this.state.address,
			city: this.state.city,
			country: this.state.country,
			phone: this.state.phone,
			acceptDataPrivacy: this.state.acceptDataPrivacy,
			configuration291: this.state.configuration291, // honeypot
			"g-recaptcha-response": token,
			configuration: store.productConfigurationStore.getReadableModuleSelection().join("\n"),
			salesPartnerEmail: store.zipZonesStore?.selectedPartner?.email || "",
		};

		const formData = new FormData();
		for (const field in emailBody) {
			formData.append(field, emailBody[field]);
		}
		try {
			this.setState({ isSending: true });
			const response = (await this.props.apiClientDynamicBaseUrl.requestJSON(API.sendConfiguratorToCF7(store.configs?.submitCF7FormId || "-1", formData))) as any;


			if (response?.status === "mail_sent" && store.configs?.submitSuccessPagePath) {
				const successUrl = `${store.configs?.submitSuccessPagePath}?salespartner=${store.zipZonesStore?.selectedPartner?.salesPartnerId}`;
				window.location.assign(successUrl); // exit react app
				store.productConfigurationStore?.resetSelection();

			} else {
				// there is something wrong
				setTimeout(() => {
					this.notificationRef.current.scrollIntoView({
						behavior: "smooth",
						block: "end",
					});
				}, 300);
			}

			this.setState({ isSending: false, response });
		} catch (error) {
			this.setState({
				isSending: false,
				response: {
					result: {
						message: store.configs?.submitErrorMessage,
					},
				},
			});

			setTimeout(() => {
				this.notificationRef.current.scrollIntoView({
					behavior: "smooth",
					block: "end",
				});
			}, 300);
		}
	};

	handleChange = (childValue: string, childName: string) => {
		// @ts-ignore
		this.setState({ [childName]: childValue });
	};

	setupEmailFallbackBody = () => {
		return `${this.state.firstname} ${this.state.lastname} %0D%0A
			${this.state.email}%0D%0A
			${this.state.phone}%0D%0A
			${this.state.message}%0D%0A
			${store.productConfigurationStore?.getReadableModuleSelection()}`;
	};

	render() {
		return (
			<form className="submit-form" onSubmit={this.handleSubmit}>
				<div className="form-group">
					<FormInput
						onChange={this.handleChange}
						inputText={this.state.firstname}
						type={"text"}
						name={"firstname"}
						label={store.configs?.submitFieldPlaceholderFirstname}
						required={true}
					></FormInput>
					<FormInput
						onChange={this.handleChange}
						inputText={this.state.lastname}
						type={"text"}
						name={"lastname"}
						label={store.configs?.submitFieldPlaceholderLastname}
						required={true}
					></FormInput>
					<FormInput
						onChange={this.handleChange}
						inputText={this.state.email}
						type={"email"}
						name={"email"}
						label={store.configs?.submitFieldPlaceholderEmail}
						required={true}
					></FormInput>
					<FormInput
						onChange={this.handleChange}
						inputText={this.state.phone}
						type={"text"}
						name={"phone"}
						label={store.configs?.submitFieldPlaceholderPhone}
						required={true}
					></FormInput>
					<FormInput
						onChange={this.handleChange}
						inputText={this.state.address}
						type={"text"}
						name={"address"}
						label={store.configs?.submitFieldPlaceholderAddress}
						required={true}
					></FormInput>
					<FormInput
						onChange={this.handleChange}
						inputText={this.state.postcode}
						type={"text"}
						name={"postcode"}
						label={store.configs?.submitFieldPlaceholderPostcode}
						required={true}
					></FormInput>
					<FormInput
						onChange={this.handleChange}
						inputText={this.state.city}
						type={"text"}
						name={"city"}
						label={store.configs?.submitFieldPlaceholderCity}
						required={true}
					></FormInput>
					<FormInput
						onChange={this.handleChange}
						inputText={this.state.country}
						type={"text"}
						name={"country"}
						label={store.configs?.submitFieldPlaceholderCountry}
						required={true}
					></FormInput>
					<FormInput
						onChange={this.handleChange}
						inputText={this.state.message}
						type={"textarea"}
						name={"message"}
						label={store.configs?.submitFieldPlaceholderMessage}
					></FormInput>
					<FormInput
						onChange={this.handleChange}
						inputText={this.state.configuration291}
						type={"text"}
						name={"configuration291"}
						labelStyle={{ position: "absolute", left: -9999 }}
						style={{ position: "absolute", left: -9999 }}
						label={store.configs?.submitFieldPlaceholderMessage}
					></FormInput>
				</div>
				<label className={`multi-select-label`} style={{ alignItems: "flex-start", justifyContent: "space-between", marginBottom: 20 }}>
					<input
						required
						type="checkbox"
						className="multi-select-check-input"
						value={this.state.acceptDataPrivacy}
						onChange={(e) =>
							this.state.acceptDataPrivacy.length === 0 ? this.setState({ acceptDataPrivacy: "accept" }) : this.setState({ acceptDataPrivacy: "" })
						}
						checked={this.state.acceptDataPrivacy.length > 0}
					/>
					<span style={{ height: "auto" }}>
						{store.configs?.submitFieldPrivacyPolicyLabel}
						<br></br>
						<a href={`${store.configs?.submitFieldPrivacyPolicyPath}`} target="_blank" rel="noopener noreferrer">
							{store.configs?.submitFieldPrivacyPolicyLinkTitle}
						</a>
					</span>
				</label>
				<input type="submit" className="btn btn-primary" disabled={this.state.isSending} value={store.configs?.submitSubmitCtaText || ""} />
				<div style={{ display: this.state.isSending ? "block" : "none" }}>
					<MiniLoadingIndicatorWrapper />
				</div>
				<ReCAPTCHA
					ref={this.recaptchaRef}
					sitekey={RECAPTCHA_KEY}
					size="invisible"
				/>
				<div ref={this.notificationRef}>
					{this.state.response && this.state.response.status && (
						<>
							{this.state.response.status === "mail_sent" ? (
								<div className="success">
									<div className="success-box">
										<p>{this.state.response.message}</p>
									</div>
								</div>
							) : (
									<div className="error">
										<div className="error-box">
											<p>{this.state.response.message || store.configs?.submitErrorMessage}</p>
											{store.configs?.salesPartnerDefaultMailAddress && (
												<a href={`mailto:${store.configs?.salesPartnerDefaultMailAddress}?body=${this.setupEmailFallbackBody()}`}>
													{store.configs?.salesPartnerDefaultMailAddress}
												</a>
											)}
										</div>
									</div>
								)}
						</>
					)}
				</div>
			</form>
		);
	}
}

export default Formular;
